import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueResource from "vue-resource";

Vue.config.productionTip = false;
Vue.use(VueResource);

Vue.prototype.BO_API_URL = (process.env.VUE_APP_BO_API_URL || "").replace(/\/+$/, "");
Vue.prototype.ADMIN_API_URL = process.env.VUE_APP_ADMIN_API_URL;
Vue.prototype.IMAGE_SERVER_API_URL = process.env.VUE_APP_IMAGE_SERVER_API_URL;
Vue.prototype.DINER_APP_URL = process.env.VUE_APP_DINER_APP_URL;
Vue.prototype.PAYMENT_APP_URL = process.env.VUE_APP_PAYMENT_APP_URL;
Vue.prototype.EVM_API_URL = process.env.VUE_APP_EVM_API_URL;
Vue.prototype.NODE_ENV = process.env.NODE_ENV;

document.title = process.env.VUE_APP_TITLE;

Vue.http.interceptors.push(request => {
	var token = localStorage.getItem("admin_user_token");
	if (token) {
		request.headers.set("Authorization", "Bearer " + token);
	}

	const requestUrl = request.url;
	console.log({requestUrl});
	var eventServerIdentifier = "api.obvvy.com";

	// adding headers for request except customer server api
	if (requestUrl.includes(eventServerIdentifier)) {
		if (process.env.NODE_ENV === "production") {
			request.headers.set("App-Id", "digitory-admin");
			request.headers.set("App-Code", "99aecc08-f6d4-4191-833b-4b1ba68a2852");
		} else {
			request.headers.set("App-Id", "staging-admin");
			request.headers.set("App-Code", "ddca53e4-6b39-45bc-876c-cc01268c9ca3");
		}
	}

	// return response callback
	return function (response) {
		if (response.status === 401) {
			localStorage.removeItem("login_user");
			this.$router.push({
				name: "login"
			});
			return;
		}
	};
});

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount("#app");

